import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';

import Products from '../containers/inventories/Products';
import InventoriesDash from '../containers/inventories/InventoriesDash';
import Ingredients from '../containers/inventories/Ingredients';
import Categories from '../containers/inventories/Categories';
import Error404 from '../containers/Error404';
import CheckPermission from "../components/extras/CheckPermission";
import StockMovementsProducts from "../containers/inventories/StockMovementsProducts";
import StockMovementsIngredients from "../containers/inventories/StockMovementsIngredients";
import ShoppingList from "../containers/inventories/ShoppingList";
import Recipes from "../containers/inventories/Recipes";
import Warehouse from "../containers/inventories/Warehouse";
import StockMovementsWarehouse from "../containers/inventories/StockMovementsWarehouse";

class InventoriesRoute extends Component {

    render() {
        return (
            <div>
                {this.props.children}
                <Switch>
                    <Route exact path={this.props.match.path} component={InventoriesDash}/>
                    <Route exact path={`${this.props.match.path}/products`} component={Products}/>
                    <Route exact path={`${this.props.match.path}/ingredients`} component={Ingredients}/>
                    <Route exact path={`${this.props.match.path}/categories`} component={Categories}/>
                    <Route exact path={`${this.props.match.path}/shopping-list`} component={ShoppingList}/>
                    <Route exact path={`${this.props.match.path}/stock-movements-products`} component={StockMovementsProducts}/>
                    <Route exact path={`${this.props.match.path}/stock-movements-ingredients`} component={StockMovementsIngredients}/>
                    <Route exact path={`${this.props.match.path}/stock-movements-warehouse`} component={StockMovementsWarehouse}/>
                    <Route exact path={`${this.props.match.path}/recipes`} component={Recipes}/>
                    <Route exact path={`${this.props.match.path}/warehouse`} component={Warehouse}/>
                    <Route exact path={'*'} component={Error404}/>
                </Switch>
                <CheckPermission access='inventories_view'/>
            </div>
        );
    }
}

export default InventoriesRoute;



// WEBPACK FOOTER //
// ./src/routes/InventoriesRoute.js